export function getMaterialName(type: string | string[] | undefined, t: (key: string) => string) {
  if (Array.isArray(type)) {
    return t('material_name_collection');
  } else {
    switch (type) {
      case 'BlogPost':
        return t('material_name_blog-post');
      case 'Contact':
        return t('material_name_contact');
      case 'Document':
        return t('material_name_document');
      case 'Event':
        return t('material_name_event');
      case 'Image':
        return t('material_name_image');
      case 'News':
        return t('material_name_news');
      case 'Pressrelease':
        return t('material_name_press-release');
      case 'Video':
        return t('material_name_video');
      default:
        return t('material_name_generic');
    }
  }
}

export function getMaterialPluralName(
  type: string | string[] | undefined,
  t: (key: string) => string,
) {
  if (Array.isArray(type)) {
    return t('material_name_collection');
  } else {
    switch (type) {
      case 'BlogPost':
        return t('material_name_blog-post_plural');
      case 'Contact':
        return t('material_name_contact_plural');
      case 'Document':
        return t('material_name_document_plural');
      case 'Event':
        return t('material_name_event_plural');
      case 'Image':
        return t('material_name_image_plural');
      case 'News':
        return t('material_name_news_plural');
      case 'Pressrelease':
        return t('material_name_press-release_plural');
      case 'Video':
        return t('material_name_video_plural');
      default:
        return t('material_name_generic_plural');
    }
  }
}

export function getMaterialStatusLabel(status: string | undefined, t: (key: string) => string) {
  switch (status) {
    case 'published':
      return t('material_state_published');
    case 'scheduled':
      return t('material_state_scheduled');
    case 'draft':
      return t('material_state_draft');
    case 'archived':
      return t('material_state_archived');
    default:
      return '';
  }
}

export function getEmptyFilterResultHeadline(
  status: string | undefined,
  type: string | string[] | undefined,
  t: (key: string, args?: Record<string, string | number> | undefined) => string,
) {
  const pluralName = getMaterialPluralName(type, t);
  const name = getMaterialName(type, t);
  switch (status) {
    case 'scheduled':
      return t('material_search_no-scheduled', { pluralName });
    case 'sticky':
      return t('material_search_no-pinned', { pluralName });
    case 'draft':
      return t('material_search_no-draft', { name }); // single
    case 'published':
      return t('material_search_no-published', { pluralName });
    case 'archived':
      return t('material_search_no-archived', { pluralName });
    case 'expiration':
      return t('material_search_no-deletion', { pluralName });
    default:
      return t('material_search_no-matches', { pluralName });
  }
}
